import http from 'hub-http/clients/apiClient';
import userInfo from 'hub-http/userInfo';

type $tsMigrateAny = any;

const BASE_URI = 'users/v1/app/attributes';
const BULK_GET_URI = `${BASE_URI}/bulk-get`;

export function fetchUserSetting(keys: $tsMigrateAny) {
  return userInfo().then(({ user }) => {
    const formattedKeys = Array.isArray(keys) ? keys : [keys];
    return http
      .put(BULK_GET_URI, {
        data: {
          keys: formattedKeys,
          user_id: user.user_id,
        },
      })
      .then((settings) => {
        return (settings as $tsMigrateAny).attributes.reduce(
          (acc: $tsMigrateAny, setting: $tsMigrateAny) => {
            if (!(setting && setting.value)) {
              return acc;
            }
            const parsedSetting = JSON.parse(setting.value);
            /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
            return { ...acc, ...parsedSetting };
          },
          {}
        );
      });
  });
}

export function saveUserSetting(
  settingName: $tsMigrateAny,
  key: $tsMigrateAny,
  value: $tsMigrateAny
) {
  return userInfo().then(({ user }) => {
    const uriKey = encodeURIComponent(settingName);
    const uriUserId = encodeURIComponent(user.user_id);
    return http.post(`${BASE_URI}?key=${uriKey}&user_id=${uriUserId}`, {
      data: {
        key: uriKey,
        value: JSON.stringify({ [key]: value }),
      },
    });
  });
}
